import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1700To1799Service {

  constructor() { }
}
